import React from "react";
import "./StoryImages.scss"

const StoryImages = ({ value }) => {
	return (
		<div className="gallery-wrap">
			<img
				src={value?.desktopImage?.asset?.url}
				width={value?.desktopImage?.asset?.width}
				height={value?.desktopImage?.asset?.height}
				alt={value?.desktopImage?.altText}
				className='desktop-only'
				loading='lazy'
			/>
			<img
				src={value?.mobileImage?.asset?.url}
				width={value?.mobileImage?.asset?.width}
				height={value?.mobileImage?.asset?.height}
				alt={value?.mobileImage?.altText}
				className='mobile-only'
				loading='lazy'
			/>
		</div>
	)
}

export default StoryImages